export const CALL = "CALL";
export const REMOVE = "REMOVE";
export const ADD = "ADD";
export const INC = "INC";
export const DEC = "DEC";
export const CHANGE_PRICE = "CHANGE_PRICE";
export const SET_PREV_PRICE = "SET_PREV_PRICE";
export const CLEAR_CART = "CLEAR_CART";
